export default {
      id: "deco_e-usage",
      viewBox: "0 0 310 255",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco_e-usage",
      toString: function () {
        return this.url;
      }
    }